module.exports = ".brd-content {\n  height: 850px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/submission/components/powerbi-report-viewer/powerbi-report-viewer.component.scss
// module id = ./src/app/submission/components/powerbi-report-viewer/powerbi-report-viewer.component.scss
// module chunks = main